<template>
  <div class="channel-all-container">
    <commonHeader></commonHeader>
    <ul v-infinite-scroll="getList"
        infinite-scroll-disabled="noMore"
        infinite-scroll-distance="10">
      <channelList :list.sync="list"
                   v-if="list.length"></channelList>
    </ul>
    <no-data v-if="!list.length"
             :text="textTip"></no-data>
  </div>
</template>
<script>
import commonHeader from '../common/commonHeader'
import channelList from './channelList'
import utils from '@ivy/fts/utils'
import axios from 'axios'
import { transAliImgResize } from '../../util'
import noData from '../comps/noData'
export default {
  data() {
    return {
      list: [],
      noMore: false,
      limit: 10,
      couponId: '',
      usedScope: '',
      fetchInterface: ''
    }
  },
  computed: {
    textTip() {
      return this.couponId ? '优惠券暂无可使用课程' : '暂无课程'
    }
  },
  async mounted() {
    await this.$store.login()
    this.couponId = this.$route.query && this.$route.query.couponId
    this.usedScope = this.$route.query && this.$route.query.usedScope
    this.fetchInterface = this.couponId ? 'getCouponCourseList' : 'getCourseList'
    this.couponId && this.$title('常青藤爸爸学堂')
    this.list = []
    this.getList()
  },
  components: {
    commonHeader,
    channelList,
    noData
  },
  methods: {
    async getList() {
      if (!this.fetchInterface) return
      let { data } = await axios.get(`/api/mobile/knowlege/course/${this.fetchInterface}`, {
        params: { limit: this.limit, offset: this.list.length, couponId: this.couponId, usedScope: this.usedScope }
      })
      data.list.forEach((item, index) => {
        data.list[index] = { ...item, pic_url: transAliImgResize(item.pic_url, 180, 180) }
      })
      data = data.list
      if (data.length) {
        this.list = [...this.list, ...data]
      }
      this.noMore = data.length < this.limit
    }
  }
}
</script>
